import { ITableTitle } from './../../../../types/table'

export const SHomeTitles: ITableTitle[] = [
  { type: 'header', slug: 'increment' },
  { type: 'header', slug: 'user' },
  { type: 'header', slug: 'delivery' },
  { type: 'header', slug: 'comment' },
  { type: 'header', slug: 'restaurant' },
  { type: 'header', slug: 'status' },
  { type: 'header', slug: 'itemsTotalPrice' },
  { type: 'header', slug: 'PaymentType' },
  { type: 'header', slug: 'created' },
  { type: 'header', slug: '' },
]
